import React from 'react';
import { Tooltip } from '@mui/material';


export const BatchGridColumns = () => [


    {    field: 'id',
        headerName: 'ID',
        sortable: true,
        width: 100,
        hide: false,
    },
    {
        field: 'type',
        headerName: 'Type',
        sortable: true,
        editable: true,
        hide: false,
        // editable: true,
        width: 200,
    },
    {
        field: 'started',
        headerName: 'Started',
        sortable: false,
        editable: true,
        width: 200,
    },
    {
        field: 'startReason',
        headerName: 'Start Reason',
        sortable: false,
        editable: true,
        width: 200,
    },
    {
        field: 'startReasonDetail',
        headerName: 'Start Reason Detail',
        sortable: false,
        editable: true,
        width: 400,
    },
    {
        field: 'ended',
        headerName: 'Ended',
        sortable: false,
        editable: true,
        width: 200,
    },
    {
        field: 'endReason',
        headerName: 'End Reason',
        sortable: false,
        editable: true,
        width: 200,
    },
    {
        field: 'endReasonDetail',
        headerName: 'End Reason Detail',
        sortable: false,
        editable: true,
        width: 400,
    }
];

